module.exports = __webpack_public_path__ + "static/media/bubble_2.9e5d74e1.png";